<template>
  <div class="planning-page">
    <planning-nav/>
    <section id="planning-page-main-content">
      <question-box :total="experienceList.length" v-if="experienceList.length > 0" />
      <experience-box :total="5" :data="experienceList" @show-recommend="isShowRecommend = true" v-if="experienceList.length > 0"/>
      <recommend-box v-if="isShowRecommend && recommendList.length > 0" :recommend-list="recommendList"/>
      <img src="https://files.wondercv.com/pc/planning/index-background1.png" alt="" class="background-img background-img1" v-show="!isShowRecommend || recommendList.length === 0">
      <img src="https://files.wondercv.com/pc/planning/index-background2.png" alt="" class="background-img background-img2" v-show="isShowRecommend && recommendList.length > 0">
      <robot :cv_token="cv_token" :typeStr="'jobRecommend'" :delayed="6000" :showRobotContent='true'></robot>
    </section>
    <div class="layer" v-if="layerState"></div>
  </div>
</template>

<script>
  import PlanningNav from "./components/planning-nav";
  import QuestionBox from "./components/question-box"
  import ExperienceBox from "./components/experience"
  import RecommendBox from "./components/recommend-box"
  import robot from "./components/robot.vue"
  import api from "../../api/index"
  import {mapState, mapMutations} from "vuex";

  export default {
    name: "planning-index",
    components: {
      PlanningNav,
      QuestionBox,
      ExperienceBox,
      RecommendBox,
      robot
    },
    data(){
      return {
        isShowRecommend: false,
        experienceList: [],
        recommendList: [],
        cv_token: ''
      }
    },
    computed:{
      ...mapState('planning', ['layerState'])
    },
    created() {
      for(let i = 0;i < 6;i++){
        this.recommendList[i] = {}
        this.recommendList[i].recommendUsers = []
        for(let m = 0;m<5;m++){
          this.recommendList[i].recommendUsers[m] = {}
          this.recommendList[i].recommendUsers[m].profession_name = "加载中..."
        }
      }
      this.$message('简历下载完成')
      this.initData()
    },
    mounted() {
      try {
        document.getElementsByTagName('body')[0].className += 'hide-udesk'
      } catch (error) {}
    },
    methods:{
      ...mapMutations('planning', ['updateResumeDetail']),
      initData(){
        let {token} = this.$route.params
        this.cv_token = token
        api.planning.getExperience(token).then(exp=>{
          if(exp.code === 1000){
            this.updateResumeDetail(exp.data)
            this.experienceList = [ ...exp.data.edus.map(item => ({...item, type: 'school'})).reverse(), ...exp.data.works.map(item => ({...item, type: 'company'})).reverse()]
          }
        })

        api.planning.getPredictiveLevel({cv_token: token}).then(level=>{
          if(level.code === 1000){
            this.recommendList = [...level.data.map(item=>({...item, recommendUsers:[]}))]
            if(this.recommendList.length>0){
              this.recommendList.forEach((item, index)=>{
                this.getRecommendUser(item.profession_id, index, token)
              })
            }
          }
        })
      },
      getRecommendUser(profession, index, cv_token){
        api.planning.getPredictiveLevelToUser({profession, cv_token}).then(res=>{
          if(res.code === 1000){
            this.$set(this.recommendList[index], 'recommendUsers', res.data)
          }
        })
      }
    },
    watch: {
      isShowRecommend: function(value){
        if(value && this.recommendList.length > 0){
          setTimeout(()=>{
            document.querySelector(".background-img2").style.transition = 'opacity 0.5s linear 1.2s'
            document.querySelector(".background-img2").style.opacity = 1
          })
        }
      },
      recommendList: function(value){
        if(value.length > 0 && this.isShowRecommend){
          setTimeout(()=>{
            document.querySelector(".background-img2").style.transition = 'opacity 0.5s linear 1.2s'
            document.querySelector(".background-img2").style.opacity = 1
          })
        }
      },
    }
  }
</script>
<style>
  body::-webkit-scrollbar{
    display: none;
  }
</style>
<style scoped lang="scss">

  ::v-deep #udesk_container{
    display: none !important;
  }
.planning-page{
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  background: #202329;
  padding: 90px 0 0 0;
  #planning-page-main-content{
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 150px 0;
    display: flex;
    height: auto;
    position: relative;
    .background-img{
      position: absolute;
      z-index: 0;
      &.background-img1{
        width: 790px;
        height: 667px;
        left: 468px;
        top: 94px;
      }
      &.background-img2{
        width: 1046px;
        height: 663px;
        left: 320px;
        top: -60px;
        opacity: 0;
      }
    }
  }
  .layer{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }
}
</style>
